import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Image from '../global/Image';
import FadeIn from "react-lazyload-fadein";

export default class PageTeam extends Component {
	
	constructor(){
		super()
		this.state = {
			active: 0,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
	
	handleToggle(_evt) {  
	    this.setState({ active : parseFloat(_evt.currentTarget.getAttribute('data-index')) });
    }
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <>
				
					{block.heading &&
						
						<div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-small'}>
				    	
				    		<div className="l-content l-content--fixed-width">
				    		
				    			<div className="l-grid">
				    		
					    			<div className="l-grid__col">
						    			<h2 className="c-paragraph c-paragraph--xlarge" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
						    		</div>
								
								</div>
								
							</div>
							
						</div>
						
					}
					
					{block.format == 'grid' &&
						
						<div className={'c-page__block c-page__block--space-' + block.space_after + ' c-page__block--load-effect'}>
						
							<div className="l-content l-content--fixed-width">
			    				
			    				<div className="l-grid">
			    				
			    					<div className="l-grid__col">
			    						
			    						{block.agents &&
				    						
				    						<div className="c-property-thumbs">
			    							
				    							{block.agents.map((agent,i) => 
													{
														return (
															<div className="c-property-thumbs__thumb" key={i}>
			
																<div className="c-property-thumbs__thumb__link">
																	
																	<Link to={agent.url} className="c-property-thumbs__thumb__image">
																		
																		{agent.srcset && 
																			<FadeIn>
																				{onload => (
																					<img
																						alt={""} 
																						src={agent.src} 
																						srcSet={agent.srcset} 
																						onLoad={onload}
																					/>
																				)}
																			</FadeIn>
																		}
																		{!agent.srcset && 
																			<FadeIn>
																				{onload => (
																					<img
																						alt={""} 
																						src={agent.src} 
																						onLoad={onload}
																					/>
																				)}
																			</FadeIn>
																		}
																		
																	</Link>
																	
																	<div className="c-property-thumbs__thumb__text">
																	
																		<div className="c-property-thumbs__thumb__text__wide">
																			{agent.name && agent.role &&
																				<p className="c-paragraph" dangerouslySetInnerHTML={{__html:agent.name + ' - ' + agent.role}}></p>
																	    	}
																	    	{agent.name && !agent.role &&
																	    		<p className="c-paragraph" dangerouslySetInnerHTML={{__html:agent.name}}></p>
																	    	}
																	    	{agent.phone && 
																	    		<p className="c-paragraph" dangerouslySetInnerHTML={{__html:'Phone ' + agent.phone}}></p>
																	    	}
																	    	{agent.email && 
																	    		<p className="c-paragraph" dangerouslySetInnerHTML={{__html:'Email ' + agent.email}}></p>
																	    	}

																		</div>
																		
																	</div>
																	
																</div>
															
															</div>
														)
													}
												)}
				    						
				    						</div>
				    						
			    						}
			    						
			    					</div>
			    					
			    				</div>
			    		
							</div>
			    		
			    		</div>
		    		
					}
					
					{block.format != 'grid' &&
						
						<>
					
							<div className={'c-team c-page__block c-page__block--load-effect c-page__block--space-small'}>
						    	
					    		<div className="l-content l-content--fixed-width">
					    		
					    			<div className="l-grid">
					    		
						    			<div className="l-grid__col l-grid__col--m-6-12">
											<ul className="c-team__list">
												{block.agents.map((agent,i) =>
													{	
														if (i === this.state.active) {
															return (
																<li key={i} className="c-team__list__item state-active" dangerouslySetInnerHTML={{__html:agent.name}} key={i}></li>
															)
														} else {
															return (
																<li key={i} className="c-team__list__item" key={i}>
																	<a className="c-team__list__link" onClick={this.handleToggle} data-index={i}dangerouslySetInnerHTML={{__html:agent.name}}></a>
																</li>
															)
														}
													}
													)}	
											</ul>
										</div>
						    		
						    			<div className="c-team__right l-grid__col l-grid__col--m-6-12">
							    			<div className="c-team__profiles">
																		
												{block.agents.map((agent,i) =>
													{	
														let profileClass = 'c-team__profile';
														if (i === this.state.active) {
															profileClass = profileClass + ' state-active';
														}
														return (
															<Link to={agent.url} className={profileClass} key={i}>			
																<div className="c-team__profile__headshot">    				    
														    		<Image srcset={agent.srcset} src={agent.src}></Image>
														    	</div>												    	
														    	<div className="scope-text c-team__profile__text">
														    	
														    		<div className="c-team__profile__text__left">
														    	
															    		{agent.name && agent.role &&
																    		<p dangerouslySetInnerHTML={{__html:agent.name + '<br />' + agent.role}}></p>
																    	}
																    	{agent.name && !agent.role &&
																    		<p dangerouslySetInnerHTML={{__html:agent.name}}></p>
																    	}
																    	
																    </div>
																    	
																    <div className="c-team__profile__text__right">
															    	
																    	{agent.phone && agent.vcf_file &&
																    		<p dangerouslySetInnerHTML={{__html:'Phone ' + agent.phone + '<br /><a href="' + agent.vcf_file + '">VCard</a>'}}></p>
																    	}
																    	{agent.phone && !agent.vcf_file &&
																    		<p dangerouslySetInnerHTML={{__html:'Phone ' + agent.phone}}></p>
																    	}
																    	
																    </div>
															    
															    </div>
															    		
															</Link>
														)
													}
												)}
											
											</div>
							    		</div>
							    		
							    	</div>
					    		
								</div>
								
							</div>
							
							{block.text &&
								
								<div className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
									<div className="l-grid">
									
										<div className="l-grid__col">
										
											<div className="c-team__text">
						    						    			
												<div className={'scope-text scope-text--faded scope-text--xlarge'} dangerouslySetInnerHTML={{__html:block.text}}></div>
												
											</div>
											
										</div>
										
									</div>
								
								</div>
								
							}
							
						</>
						
					}
						
				</>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
